import React from 'react';
import { ChatGlyph } from '../chatIcons';
import classes from './Chats.module.css';

const ICON_SIZE = 26;
const ICON_STROKE = 1.6;

const ChatEmptyState = () => (
    <div className={classes.emptyState}>
        <span className={classes.emptyIcon} aria-hidden="true">
            <ChatGlyph size={ICON_SIZE} strokeWidth={ICON_STROKE} />
        </span>
        <p className={classes.emptyTitle}>No comments yet</p>
        <p className={classes.emptyHint}>Start the conversation — everyone viewing this mind map will see it live.</p>
    </div>
);

export default ChatEmptyState;
